/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCe = createReactComponent("ce", "IconCe", [
  ["path", { d: "M9 6a6 6 0 1 0 0 12", key: "svg-0" }],
  ["path", { d: "M21 6a6 6 0 1 0 0 12", key: "svg-1" }],
  ["path", { d: "M15 12h6", key: "svg-2" }]
]);

export { IconCe as default };
//# sourceMappingURL=IconCe.js.map
